import { TomOption } from 'tom-select/src/types'
import { escape_html } from 'tom-select/src/utils'
import SelectableController from './selectable_controller'

const openFacilityIcon = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" class="h-4 w-4 text-accent shrink-0">' +
  '<path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"></path>' +
  '</svg>'

export interface FacilityTomOption extends TomOption {
  name: string
  licenseNumber: string
  url: string
  invalid: boolean
}

export default class extends SelectableController {
  static values = {
    url: { type: String },
    auditorId: { type: String, default: '' }
  }

  settings = {
    searchField: ['name', 'licenseNumber'],
    plugins: ['checkbox_options', 'remove_button', 'virtual_scroll']
  }

  declare auditorIdValue: string

  buildUrl (query: string): string {
    const baseUrl = `/facilities?page=${this.currentPage}`

    if (query === '' && this.auditorIdValue === '') {
      return `${baseUrl}`
    }

    return `${baseUrl}&advanced_search=true` +
      (query === ''
        ? ''
        : `&q[g][0][c][0][a][0][name]=fields.license_number&q[g][0][c][0][p]=cont&q[g][0][c][0][v][0][value]=${encodeURIComponent(query)}` +
        `&q[g][0][c][1][a][0][name]=name&q[g][0][c][1][p]=cont&q[g][0][c][1][v][0][value]=${encodeURIComponent(query)}&q[g][0][m]=or`) +
      ((this.auditorIdValue === '') ? '' : `&q[g][1][c][0][a][0][name]=auditor_id&q[g][1][c][0][p]=eq&q[g][1][c][0][v][0][value]=${this.auditorIdValue}`)
  }

  renderOption (data: FacilityTomOption, escape: typeof escape_html): HTMLElement {
    const optionElement = document.createElement('div')
    optionElement.innerHTML = `<div class="option-link"><div class="flex items-center space-x-1.5"><p>${escape(data.name)}</p>` +
      (data.url.length === 0 ? '' : `<a href="${escape(data.url)}" target="_blank">${openFacilityIcon}</a></div>`) +
      `<p class="text-sm font-normal text-secondary">${escape(data.licenseNumber)}</p></div>`

    if (data.url.length > 0) {
      const facilityAnchor = optionElement.querySelector('a') as HTMLAnchorElement
      facilityAnchor.addEventListener('click', (event) => {
        event.stopPropagation()
      })
    }

    return optionElement
  }

  renderItem (data: FacilityTomOption, escape: typeof escape_html): HTMLElement {
    const optionElement = document.createElement('div')
    let nameAndLicense = escape(data.name)
    if (data.licenseNumber !== '' && data.licenseNumber !== undefined && data.licenseNumber !== null) {
      nameAndLicense += `(${escape(data.licenseNumber)})`
    }

    optionElement.innerHTML = '<div class="flex flex-row items-center w-full">' +
      (data.url.length === 0 ? '' : `<a class="h-4 w-4" href="${escape(data.url)}" target="_blank">${openFacilityIcon}</a>`) +
      `<p class="px-1${data.invalid ? ' text-stm-error-solid' : ''}">${nameAndLicense}</p></div>`

    if (data.url.length > 0) {
      const facilityAnchor = optionElement.querySelector('a') as HTMLAnchorElement
      facilityAnchor.addEventListener('click', (event) => {
        event.stopPropagation()
      })
    }

    return optionElement
  }

  changeAuditor ({ detail: { auditorId } }: { detail: { auditorId: string } }): void {
    this.auditorIdValue = auditorId
  }

  protected clearAndReload (): void {
    if (this.plugin == null) return

    this.plugin.clear(true)
    this.plugin.clearOptions()

    this.currentPage = 1
    this.nothingMoreToLoad = false

    this.plugin.load('')
  }

  auditorIdValueChanged (): void {
    this.clearAndReload()
  }
}
